export const integrationsDirectCdiSnowflakeWifPrincipalAppGroupId =
  "/integrations/direct/cdi/snowflake-wif-principal/:app_group_id";
